import './index.css'
import { ConfigProvider, App } from 'antd'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import AppRoutes from './routes/AppRoutes'
import { inject } from '@vercel/analytics'
import { BrowserRouter as Router } from 'react-router-dom'
import frFR from 'antd/locale/fr_FR'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.rock-your\.careers/],
  environment: import.meta.env.VITE_ENVIRONMENT,
  release: 'ryc-employee-frontend@' + import.meta.env.npm_package_version,
})

// Enable Vercel analytics
inject({
  mode:
    import.meta.env.VITE_ENVIRONMENT === 'production'
      ? 'production'
      : 'development',
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Router basename="/">
    <App>
      <ConfigProvider
        locale={frFR}
        theme={{
          token: { colorPrimary: '#000' },
        }}
      >
        <AppRoutes />
      </ConfigProvider>
    </App>
  </Router>
)
